import React from 'react'

import CounterChart from '../../_shared/charts/counter/CounterChart'
import UsersCounterLoader, { useAllUsersCounter, useUsersCounter } from './_load/UsersCounterLoader'
import WidgetWrapper from '../../WidgetWrapper'

const Widget = props => {
  const { widget } = props
  const value = useUsersCounter()
  const all = useAllUsersCounter()

  return <CounterChart value={value} all={all} name={widget.name} {...widget.data} />
}

const Wrapper = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <UsersCounterLoader widget={widget}>
        <Widget widget={widget} />
      </UsersCounterLoader>
    </WidgetWrapper>
  )
}

export default Wrapper
